import { render } from "./QuestionCard.vue?vue&type=template&id=cfd928f6&scoped=true&ts=true"
import script from "./QuestionCard.vue?vue&type=script&lang=ts"
export * from "./QuestionCard.vue?vue&type=script&lang=ts"

import "./QuestionCard.vue?vue&type=style&index=0&id=cfd928f6&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd928f6"]])

export default __exports__